import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import InputFile from '../../FormFields/File';
import Button from '../../Common/Button';
import Icon from '../../Common/Icon';
import DFFPhotoService from '../../../Services/DFFPhotoService';
import { ReactComponent as CloseIcon } from '../../../../img/dialog-close.svg';

class ModalFieldPhoto extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      photos: this.props.data.photo
    };
  }

  handleChange = (photos) => {
    this.setState({ photos });
  };

  onPressClose = (event) => {
    this.props.onClose(event);
  };

  onPressSave = (event) => {
    const { configuration, api } = this.props;
    const { photos } = this.state;
    DFFPhotoService.addPhotos(api, configuration, photos);
    this.props.onClose(event);
  };

  render() {
    const { photos } = this.state;

    return (
      <Modal isOpen onRequestClose={this.onPressClose} contentLabel="Add note" className="Modal_Content" overlayClassName="Modal_Overlay">
        <div className="Modal_Content_Container Center">
          <h2>ATTACH PHOTO</h2>
          <InputFile
            accept="image/*"
            multiple
            comments
            value={photos}
            placeholder="Drag your photo here or click to upload"
            onChange={this.handleChange}
          />
          <div className="Modal_Content_Actions Center">
            <Button className="Button_Small Inline" onClick={this.onPressSave}>
              Save
            </Button>
            <Button className="Button_Small Button_Cancel Inline" onClick={this.onPressClose}>
              Cancel
            </Button>
          </div>
          <div className="Modal_Content_Close" onClick={this.onPressClose}>
            <Icon className="Icon-Close" width="12" height="12" color="secondaryColor">
              <CloseIcon alt="icon-close" />
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalFieldPhoto.propTypes = {
  configuration: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  api: LfaContextAPIShape,
  onClose: PropTypes.func.isRequired,
  multiple: PropTypes.bool
};

ModalFieldPhoto.defaultProps = {
  multiple: true
};

export default ModalFieldPhoto;
